import { render, staticRenderFns } from "./ThemedColumnText.vue?vue&type=template&id=b22a3378&scoped=true&"
import script from "./ThemedColumnText.vue?vue&type=script&lang=js&"
export * from "./ThemedColumnText.vue?vue&type=script&lang=js&"
import style0 from "./ThemedColumnText.vue?vue&type=style&index=0&id=b22a3378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22a3378",
  null
  
)

export default component.exports